import Util from "../../global/utils/Helpers";
import data from "../../data/schema/shared/sharedData";

const datahubProxy = "datahub-search";

const apiIndex = Util.isLocalhost()
  ? `/${datahubProxy}`
  : `${Util.getCurrentHost()}/${datahubProxy}`;

const mappers = {
  getCounties: async (year = data.indexYear) => {
    return fetch(`${apiIndex}/countiesBlsByState/${year}`, {
      headers: {
        "Cache-Control": "no-cache",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
  },
  getBlsAreas: async (year = data.indexYear) => {
    return fetch(`${apiIndex}/countiesByBlsArea/${year}`, {
      headers: {
        "Cache-Control": "no-cache",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
  },
};
export default mappers;
